import { TActions } from '../../../AppModulesWrapper';

import { LOAD_BET_POSITION_START, LOAD_BET_POSITION_SUCCESS, LOAD_BET_POSITION_FAIL } from '../../actions/betPosition';
import { RESET_STATE } from '../../actions/resetState';
import { IBetPositionState, EBetPositionStatus } from '../../types/reducers/betPosition';

export const defaultState: IBetPositionState = {
  status: EBetPositionStatus.initial,
  positionByService: {},
};

export function betPosition(state: IBetPositionState = defaultState, action: TActions): IBetPositionState {
  switch (action.type) {
    case LOAD_BET_POSITION_START: {
      return {
        ...state,
        status: EBetPositionStatus.pending,
      };
    }

    case LOAD_BET_POSITION_SUCCESS: {
      return {
        ...state,
        status: EBetPositionStatus.success,
        positionByService: action.payload,
      };
    }

    case LOAD_BET_POSITION_FAIL: {
      return {
        ...state,
        status: EBetPositionStatus.fail,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
